import { resolveSettingsSections } from '@/features/campaign-whatsapp-ai-config/settings-sections'
import { CampaignNav } from '@/ui'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/company/$companyId/$campaignId/settings')({
	component: RouteComponent,
})

function RouteComponent() {
	const { companyId, campaignId } = Route.useParams()
	const { t } = useTranslation('common')
	const sections = resolveSettingsSections({
		interview: true,
		whatsappAi: useBooleanFlagValue('whatsapp-ai-agent', false),
	})

	return (
		<CampaignNav activeCampaignNavLink="settings">
			<div className="flex gap-8 py-8">
				<nav className="sticky top-[calc(var(--main-nav-height)_+_var(--campaign-nav-height)_+_1rem)] w-56 shrink-0 space-y-1 self-start">
					{sections.map((section) => (
						<Link
							key={section.to}
							to={section.to}
							params={{ companyId, campaignId }}
							className="block w-full rounded-lg px-4 py-2.5 text-left text-sm font-medium transition-colors hover:bg-grey-100"
							inactiveProps={{ className: 'text-grey-700' }}
							activeProps={{ className: 'bg-brand-50 text-brand-700' }}
						>
							{t(section.labelKey)}
						</Link>
					))}
				</nav>
				<div className="min-w-0 flex-1">
					<Outlet />
				</div>
			</div>
		</CampaignNav>
	)
}
